import AWS from 'aws-sdk';
import { nanoid } from 'nanoid';

const S3_BUCKET = 'neon-static';
const REGION = 'us-east-1';

AWS.config.update({
  accessKeyId: 'AKIAZVVDPOKRNTAQYPNE',
  secretAccessKey: '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',
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

export const uploadToS3 = async (file: File, group?: string) => {
  return new Promise((res) => {
    const key = `${group}${group ? '/' : ''}${nanoid()}`;
    const params = {
      ACL: 'public-read',
      Body: file,
      Bucket: S3_BUCKET,
      Key: key,
    };

    myBucket
      .putObject(params)
      .on('complete', () => {
        res(key);
      })
      .send((err) => {
        if (err) console.log(err);
        res(key);
      });
  });
};
